import api from "@/Library/api.js";

export default {

    GET_SHOP_PHOTO_CATE_LIST(data) {
        return api({ url: "/Shopphoto/ShopPhotoCateList", method: "post", data: data });
    },

    GET_SHOP_PHOTO_CATE_LIST_FOR_CASCADE(data) {
        return api({ url: "/Shopphoto/SystemPhotoCateListForCascade", method: "post", data: data });
    },

    ADD_SHOP_PHOTO_CATE(data) {
        return api({ url: "/Shopphoto/SystemPhotoCateAdd", method: "post", data: data });
    },

    CHANGE_SHOP_PHOTO_CATE_NAME(data) {
        return api({ url: "/Shopphoto/SystemPhotoCateNameChange", method: "post", data: data });
    },

    SORT_SHOP_PHOTO_CATE(data) {
        return api({ url: "/Shopphoto/SystemPhotoCateSort", method: "post", data: data });
    },

    DEL_SHOP_PHOTO_CATE(data) {
        return api({ url: "/Shopphoto/SystemPhotoCateDel", method: "post", data: data });
    },

    ADD_SHOP_PHOTO(data) {
        return api({ url: "/Shopphoto/SystemPhotoAdd", method: "post", data: data });
    },

    CHANGE_SHOP_PHOTO_NAME(data) {
        return api({ url: "/Shopphoto/SystemPhotoNameChange", method: "post", data: data });
    },

    DEL_SHOP_PHOTO(data) {
        return api({ url: "/Shopphoto/SystemPhotoDel", method: "post", data: data });
    },

    GET_SHOP_PHOTO_LIST(data) {
        return api({ url: "/Shopphoto/SystemPhotoList", method: "post", data: data });
    },

}
